import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { ROLE_COLORS } from './constants';

export function WeeklyLoadingChart({ timeline, roleLabels }) {
  const [viewMode, setViewMode] = useState('hours');
  const chartData = timeline.weekly_loading.map(w => {
    const entry = { week: `W${w.week}` };
    if (viewMode === 'hours') {
      Object.entries(w.role_hours || {}).forEach(([role, hrs]) => { entry[roleLabels[role] || role] = hrs; });
    } else {
      Object.entries(w.roles).forEach(([role, fte]) => { entry[roleLabels[role] || role] = fte; });
    }
    return entry;
  });
  const activeRoles = Object.keys(ROLE_COLORS).filter(role =>
    timeline.weekly_loading.some(w => viewMode === 'hours' ? (w.role_hours || {})[role] : w.roles[role])
  );

  return (
    <Card data-testid="weekly-loading-chart">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <CardTitle className="text-sm font-semibold text-[#0F2040]">Weekly Resource Loading</CardTitle>
        <div className="flex items-center gap-1 bg-slate-100 rounded-md p-0.5" data-testid="loading-view-toggle">
          <button className={`text-[10px] px-2 py-1 rounded transition-colors ${viewMode === 'hours' ? 'bg-white shadow-sm font-semibold text-[#0F2040]' : 'text-slate-500'}`}
            onClick={() => setViewMode('hours')}>Hours</button>
          <button className={`text-[10px] px-2 py-1 rounded transition-colors ${viewMode === 'fte' ? 'bg-white shadow-sm font-semibold text-[#0F2040]' : 'text-slate-500'}`}
            onClick={() => setViewMode('fte')}>FTE</button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis dataKey="week" tick={{ fontSize: 9 }} />
              <YAxis tick={{ fontSize: 10 }} label={{ value: viewMode === 'hours' ? 'Hours' : 'FTE', angle: -90, position: 'insideLeft', style: { fontSize: 10 } }} />
              <Tooltip contentStyle={{ fontSize: 11 }} formatter={(value) => viewMode === 'hours' ? `${value} hrs` : `${value} FTE`} />
              <Legend wrapperStyle={{ fontSize: 10 }} />
              {activeRoles.map(role => (<Bar key={role} dataKey={roleLabels[role] || role} stackId="a" fill={ROLE_COLORS[role]} />))}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
